<template>
  <div class="img_box" @click="insLogin">
    <img class="login_other_img" src="../../../assets/img/h5_login_icon03.png" />
  </div>
</template>
<script>

export default {
  name: "LoginApple",
  data() {
    return {
      baseUrl:'https://api.instagram.com',
      appId:'886870835212249',
      redirectUri:'https://www.facecast.xyz/'
    };
  },
  mounted() {
    //this.twws()
  },
  methods: {
    insLogin(){
      //https://appleid.apple.com/auth/authorize?client_id=com.360buy.jdmobile.signInWithApple&redirect_uri=https%3A%2F%2Fplogin.m.jd.com%2Fcgi-bin%2Fml%2Fapplecallback&response_type=code%20id_token&state=ubfshuyv&scope=email&response_mode=form_post&frame_id=a5fcbc56-5db0-46c5-8080-4a03b1745b20&m=11&v=1.5.3
      //https://api.instagram.com/oauth/authorize/?client_id=CLIENT-ID&amp;redirect_uri=REDIRECT-URI&amp;response_type=code
      let a = "https://api.instagram.com/oauth/authorize/?client_id="+this.appId
      +"&redirect_uri="+this.redirectUri
      +"&scope=user_profile,user_media&response_type=code&state=1";
      console.log(a);
     window.location.href=a
      //回调之后，可在链接中获取到授权码code
  },
  }
};
</script>
<style scoped>
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginSdk/LoginSdkApple.vue